var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeSpent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#g);}.g{fill:url(#h);}.h{fill:url(#i);}.i{fill:url(#j);}.j{fill:url(#k);}.k{fill:url(#l);}.l{fill:url(#m);}.m{fill:url(#n);}.n{fill:url(#o);}.o{fill:url(#p);}.p{fill:url(#q);}.q{fill:url(#r);}.r{fill:url(#s);}.s{fill:url(#t);}.t{fill:url(#u);}.u{fill:url(#v);}.v{fill:url(#w);}.w{fill:url(#x);}.x{fill:url(#y);}.y{fill:url(#z);}.z{fill:url(#aa);}.aa{fill:url(#ab);}.ab{fill:url(#ac);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.348,
    y1: 0.348,
    x2: 0.937,
    y2: 0.937,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -4.357,
    y1: 0.348,
    x2: -3.768,
    y2: 0.937,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.348,
    y1: 0.348,
    x2: 0.937,
    y2: 0.937,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.663,
    y1: 0.661,
    x2: -0.084,
    y2: -0.097,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.304,
    y1: 0.304,
    x2: 0.723,
    y2: 0.723,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 36.56,
    y1: -91.901,
    x2: 36.979,
    y2: -91.482,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 49.688,
    y1: -78.773,
    x2: 50.107,
    y2: -78.353,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 26.102,
    y1: -19.658,
    x2: 26.521,
    y2: -19.239,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 32.618,
    y1: -17.927,
    x2: 33.038,
    y2: -17.508,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 18.329,
    y1: -124.216,
    x2: 18.748,
    y2: -123.796,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 29.726,
    y1: -104.571,
    x2: 30.146,
    y2: -104.152,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -4.556,
    y1: 1.595,
    x2: -4.136,
    y2: 2.014,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -11.072,
    y1: 3.326,
    x2: -10.652,
    y2: 3.745,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 50.979,
    y1: -87.042,
    x2: 51.399,
    y2: -86.622,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 39.582,
    y1: -67.397,
    x2: 40.001,
    y2: -66.978,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.095,
    y1: 0.098,
    x2: 0.533,
    y2: 0.541,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.265,
    y1: 0.464,
    x2: 2.079,
    y2: 0.841,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.464,
    y1: 0.5,
    x2: -0.173,
    y2: 0.5,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0.652,
    y1: 0.754,
    x2: -0.323,
    y2: 0.137,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -29.768,
    y1: 25.441,
    x2: -28.796,
    y2: 25.441,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -13.456,
    y1: 0.5,
    x2: -12.456,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -14.26,
    y1: 0.632,
    x2: -14.581,
    y2: 0.311,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -106.251,
    y1: 89.506,
    x2: -105.375,
    y2: 89.506,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -2.931,
    y1: 20.614,
    x2: -1.931,
    y2: 20.614,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: -8.439,
    y1: 5.722,
    x2: -5.985,
    y2: 5.722,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: -16.347,
    y1: 5.842,
    x2: -17.962,
    y2: 5.577,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: -9.367,
    y1: 87.447,
    x2: -8.516,
    y2: 87.447,
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 0.348,
    y1: 0.348,
    x2: 0.937,
    y2: 0.937,
    xlinkHref: "#q"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 14.189,
    cy: 14.189,
    r: 14.189,
    transform: "translate(1.811 1.811)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 11.989,
    cy: 11.989,
    r: 11.989,
    transform: "translate(4.011 4.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M226.834,238.283l11.085,11.085a16.092,16.092,0,0,0,3.395-3.292l-10.963-10.963Z",
    transform: "translate(-212.601 -220.361)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.986 4.986)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.234)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 0.78,
    cy: 0.78,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(0 20.468)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.234)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(20.468)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 0.78,
    cy: 0.78,
    r: 0.78
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.35 1.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.805)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(10.159)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(0 17.769)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.805)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(17.769 10.159)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 0.78,
    cy: 0.78,
    r: 0.78
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.35 1.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.805)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 0.78,
    cy: 0.78,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(10.159 17.769)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.805)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(0 10.159)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(17.769)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 1.811)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M255,28.859V43.048l10.033,10.033A14.189,14.189,0,0,0,255,28.859Z",
    transform: "translate(-255 -28.859)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M255,63.931V75.92l8.477,8.477A11.989,11.989,0,0,0,255,63.931Z",
    transform: "translate(-239 -59.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M255.1,28.861H255V43.049l10.033,10.033a14.145,14.145,0,0,0,4.156-10.033c0-.032,0-.063,0-.1Z",
    transform: "translate(-239 -27.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M392.671,344.9l1.385,4.383.01.01a14.267,14.267,0,0,0,1.386-1.611Z",
    transform: "translate(-368.033 -323.255)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.233 14.233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M345.743,342.745l1.167,3.266.048.9c.072.2-.948,0-.948,0l-3.266-1.167C341.915,344.912,344.912,341.914,345.743,342.745Z",
    transform: "translate(-335.337 -335.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M227,230l7.238,7.238a.963.963,0,0,1,.367-.357,1.135,1.135,0,0,1,.8.017.1.1,0,0,0,.119-.137h0c-.013-.03-.025-.061-.034-.091l-.013-.044a0,0,0,0,1,0,0,.924.924,0,0,1-.026-.144c0-.016,0-.032,0-.048s0-.053,0-.079a.935.935,0,0,1,.181-.525.951.951,0,0,1,.2-.2.936.936,0,0,1,.6-.181l.048,0a.9.9,0,0,1,.144.026h0l.044.013.046.016.044.018h0a.1.1,0,0,0,.084,0,.1.1,0,0,0,.053-.118,1.134,1.134,0,0,1-.017-.8.957.957,0,0,1,.357-.367L230,227a.58.58,0,0,0-.819,0l-.427.427-1.325,1.325-.427.427A.58.58,0,0,0,227,230Z",
    transform: "translate(-226.834 -226.834)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M236.345,237.67l8.091,8.091a.1.1,0,0,0,0-.084h0a2.179,2.179,0,0,1-.074-.282c0-.016,0-.032,0-.048a.936.936,0,0,1,.181-.6.951.951,0,0,1,.2-.2.936.936,0,0,1,.6-.181l.048,0a.817.817,0,0,1,.144.026h0c.015,0,.12.041.135.048h0a.1.1,0,0,0,.084,0l-8.091-8.091Z",
    transform: "translate(-235.748 -235.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M397.319,397.319a2.087,2.087,0,0,1,.52-.38l.32.9a.253.253,0,0,1-.324.324l-.9-.32A2.087,2.087,0,0,1,397.319,397.319Z",
    transform: "translate(-386.266 -386.266)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.88 1.795)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M221.216,39.717l1.484-3.135s.545-.7.636-.505l.636.505,1.484,3.135C225.455,40.891,221.216,40.891,221.216,39.717Z",
    transform: "translate(-221.216 -35.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M225.452,95.36V85.124a.963.963,0,0,1-.512-.007,1.135,1.135,0,0,1-.551-.575.1.1,0,0,0-.181.013,0,0,0,0,1,0,0,.975.975,0,0,1-.04.089l-.022.041,0,0a.925.925,0,0,1-.083.12l-.031.037q-.027.029-.056.057a.935.935,0,0,1-.5.243.95.95,0,0,1-.286,0,.937.937,0,0,1-.555-.3l-.031-.037a.913.913,0,0,1-.083-.12l0,0-.022-.041c-.008-.015-.015-.029-.021-.044s-.013-.029-.019-.044h0a.1.1,0,0,0-.181-.013,1.134,1.134,0,0,1-.551.574.958.958,0,0,1-.512.007V95.36a.579.579,0,0,0,.579.579h3.082A.579.579,0,0,0,225.452,95.36Z",
    transform: "translate(-221.212 -80.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M241.945,96.03V84.587a.1.1,0,0,0-.06.059,0,0,0,0,1,0,0,2.173,2.173,0,0,1-.147.252c-.01.013-.021.025-.031.037a.937.937,0,0,1-.555.3.949.949,0,0,1-.286,0,.937.937,0,0,1-.555-.3.472.472,0,0,1-.031-.037.823.823,0,0,1-.083-.12l0,0c-.008-.013-.056-.114-.062-.129h0a.1.1,0,0,0-.06-.059V96.03Z",
    transform: "translate(-238.889 -81.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M245.5,29.719a2.088,2.088,0,0,1-.636-.1l.407-.86a.253.253,0,0,1,.458,0l.407.86A2.087,2.087,0,0,1,245.5,29.719Z",
    transform: "translate(-243.378 -28.615)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 2.611,
    cy: 2.611,
    r: 2.611,
    transform: "translate(13.389 13.389)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSpent);
export default __webpack_public_path__ + "static/media/time-spent.45ed2211a8789acae53556a55377709e.svg";
export { ForwardRef as ReactComponent };